// WebSocket URL helper — works the same in dev (Vite proxy at :5173 → Go at
// :5183) and in production (Go binary terminating TLS directly), regardless of
// whether the page was loaded over HTTP or HTTPS.
//
// Usage:
//
//   const ws = new WebSocket(wsURL("/api/v1/tasks/ws"));
//
// `path` may be absolute ("/api/v1/...") or already a full ws://… URL — in the
// latter case it's returned as-is.

export function wsURL(path: string): string {
	if (path.startsWith("ws://") || path.startsWith("wss://")) {
		return path;
	}
	const proto = window.location.protocol === "https:" ? "wss:" : "ws:";
	const host = window.location.host;
	const cleanPath = path.startsWith("/") ? path : "/" + path;
	return `${proto}//${host}${cleanPath}`;
}
